<div class="phases">
    <div
        (cdkDropListDropped)="drop($event, projectPhases)"
        cdkDropList
        [cdkDropListDisabled]="
            !([Functionalities.GeoManage, Functionalities.CustomerProjectsManage] | hasFunctionality) || disableDragDrop
        ">
        @for (projectPhase of projectPhases; track projectPhase) {
            <div
                (click)="selectPhase(projectPhase)"
                [class.selected]="projectPhase.id === selectedPhase?.id"
                [class.d-none]="projectPhase.done && !showDonePhases()"
                cdkDrag
                class="phase">
                <div class="prefix">
                    <div
                        [class.current]="projectPhase.id === currentProjectPhase?.id"
                        [class.done]="projectPhase.done"
                        class="icon"></div>
                    @if (
                        (Functionalities.GeoManage | hasFunctionality) ||
                        (Functionalities.CustomerProjectsManage | hasFunctionality)
                    ) {
                        <button (click)="editPhase(projectPhase)" color="primary" mat-icon-button>
                            <mat-icon class="fa fa-edit"></mat-icon>
                        </button>
                    }
                </div>
                <div class="item">
                    {{ projectPhase.name }}<br />
                    @if (projectPhase.start_date) {
                        Startdatum
                    }
                    {{ projectPhase.start_date | date: 'd MMMM yyyy' }}
                </div>
                <div class="suffix">
                    <div class="icon"></div>
                </div>
            </div>
        }
    </div>
    @if (Functionalities.CustomerProjectsManage | hasFunctionality) {
        <div class="phase add" [class.empty]="projectPhases?.length < 1">
            <div class="data">
                <button (click)="editPhase()" color="primary" mat-button>
                    Projectfase toevoegen <img src="../../../assets/images/icons/customer-projects/add.svg" />
                </button>
            </div>
        </div>
    }
</div>
